module.exports = __webpack_public_path__ + "img/WOR.2a06e02e.svg";